(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8072],{

/***/ 1424:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partner]/[city]/[slug]",
      function () {
        return __webpack_require__(5622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/common/GoogleTagManager.tsx
var GoogleTagManager = __webpack_require__(9997);
// EXTERNAL MODULE: ./store.ts
var store = __webpack_require__(7576);
// EXTERNAL MODULE: ./node_modules/@eo-locale/react/lib/index.js + 1 modules
var lib = __webpack_require__(7245);
;// CONCATENATED MODULE: ./components/GarageProfile/GarageProfileFooter.tsx



var GarageProfileFooter = /*#__PURE__*/ react.memo(function(param) {
    var garages = param.garages, current = param.current, partner = param.partner;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                className: "lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto",
                children: [
                    garages.length > 1 && partner.shouldDisplayNearby && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xl font-serif leading-8 font-semibold text-gray-500 pb-6",
                                children: "Werkst\xe4tten in der N\xe4he"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-12 grid grid-cols-2 gap-3 mb-8",
                                children: garages.map(function(garage) {
                                    var ref, ref1;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "".concat("https://www.repareo.de/", "werkstatt/").concat((ref = garage.profileSlug) === null || ref === void 0 ? void 0 : ref.split("/")[0], "/").concat(garage.id, "-").concat((ref1 = garage.profileSlug) === null || ref1 === void 0 ? void 0 : ref1.split("/")[1], "/"),
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "text-sm text-gray-500 font-normal no-underline",
                                            children: garage.name
                                        })
                                    }, garage.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "breadcrumbs col-span-full mb-4 grid md:flex justify-start gap-4 items-center text-gray-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "".concat("https://www.repareo.de/"),
                                className: "flex items-center no-underline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-home fa-fw text-gray-700 text-regular inline-block cursor-pointer mr-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-chevron-right fa-fw text-gray-700 text-regular inline-block ml-2 mr-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://www.repareo.de/werkstatt-in-deiner-naehe/",
                                className: "flex text-gray-500 no-underline font-normal items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                        id: "garage_nearby"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-chevron-right fa-fw text-gray-700 text-regular inline-block ml-2 mr-2"
                                    })
                                ]
                            }),
                            current.baseCity.published_at && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "".concat("https://www.repareo.de/", "werkstatt/").concat(current.baseCity.slug, "/"),
                                    className: "flex text-gray-500 no-underline font-normal items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                            id: "garages_in_breadcrumb",
                                            location: "".concat(current.baseCity.name),
                                            html: true,
                                            tagName: "span"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-kit fa-chevron-right fa-fw text-gray-700 text-regular inline-block ml-2 mr-2"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: current.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: "garageProfile__footer bg-gray-100 border-t-gray-200 pt-6 mt-10 pb-28 md:pb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-12 flex flex-col md:flex-row justify-center gap-x-5 text-sm mb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.repareo.de/ueber-uns-repareo/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "\xdcber uns",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "\xdcber uns"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://lp.repareo.de/ws/registrierung-ihrer-werkstatt",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "Werkstattpartner werden",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "Werkstatt\xadpartner werden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.repareo.de/datenschutzerklaerung/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "Datenschutzerkl\xe4rung",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "Datenschutz\xaderkl\xe4rung"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.repareo.de/impressum/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "Impressum",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "Impressum"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.repareo.de/haftungsausschluss/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "Haftungsausschluss",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "Haftungs\xadauschluss"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.repareo.de/hauptuntersuchung-hu-au/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "T\xdcV",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "T\xdcV"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.repareo.de/ueberblick-repareo-themenlandschaft/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: "Themenangebot",
                                        className: "leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3",
                                        children: "Themen\xadangebot"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "col-span-12 flex justify-center text-base leading-6 font-normal text-gray-400",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " repareo GmbH"
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
});
GarageProfileFooter.displayName = "GarageProfileFooter";

;// CONCATENATED MODULE: ./components/common/SchemaMarkup.tsx


var SchemaMarkup = function(param) {
    var garage = param.garage;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var days = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: garage && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "AutoRepair",
                    "name": "".concat(garage.name),
                    "image": "".concat("https://werkstatt.repareo.de/", "storage/").concat(garage.cover_image),
                    "telephone": garage.phone,
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": garage.street,
                        "addressLocality": garage.city,
                        "postalCode": garage.postcode,
                        "addressCountry": "DE"
                    },
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": garage.lat,
                        "longitude": garage.lon
                    },
                    "url": "".concat("https://www.repareo.de/", "werkstatt/").concat((ref = garage.profileSlug) === null || ref === void 0 ? void 0 : ref.split("/")[0], "/").concat(garage.id, "-").concat((ref1 = garage.profileSlug) === null || ref1 === void 0 ? void 0 : ref1.split("/")[1], "/"),
                    "description": (ref2 = garage.description) === null || ref2 === void 0 ? void 0 : ref2.replace(/(<([^>]+)>)/gi, " ").substring(0, 120),
                    "openingHoursSpecification": [
                        garage.opening_hours && garage.opening_hours.map(function(day, idx) {
                            if (day.open !== "geschlossen") {
                                return {
                                    "@type": "OpeningHoursSpecification",
                                    "dayOfWeek": "https://schema.org/".concat(days[idx]),
                                    "opens": day.open.substring(0, 5).replace(".", ":"),
                                    "closes": day.open.substring(8, 13).replace(".", ":")
                                };
                            }
                        })
                    ],
                    "aggregateRating": (garage === null || garage === void 0 ? void 0 : garage.review_count) ? {
                        "@type": "AggregateRating",
                        "bestRating": "100",
                        "ratingValue": garage === null || garage === void 0 ? void 0 : garage.rating,
                        "reviewCount": garage === null || garage === void 0 ? void 0 : garage.review_count
                    } : undefined,
                    "review": (garage === null || garage === void 0 ? void 0 : (ref3 = garage.reviews) === null || ref3 === void 0 ? void 0 : ref3.data) ? [
                        garage === null || garage === void 0 ? void 0 : (ref4 = garage.reviews) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.map(function(review) {
                            return {
                                "@type": "Review",
                                "author": {
                                    "@type": "Person",
                                    "name": review === null || review === void 0 ? void 0 : review.author
                                },
                                "datePublished": review === null || review === void 0 ? void 0 : review.published_at,
                                "reviewBody": review === null || review === void 0 ? void 0 : review.comment,
                                "reviewRating": {
                                    "@type": "Rating",
                                    "bestRating": "100",
                                    "ratingValue": review === null || review === void 0 ? void 0 : review.rating,
                                    "worstRating": "1"
                                }
                            };
                        })
                    ] : undefined,
                    "hasOfferCatalog": {
                        "@type": "OfferCatalog",
                        "name": "AutoRepair",
                        "itemListElement": [
                            garage === null || garage === void 0 ? void 0 : (ref6 = garage.availableServices) === null || ref6 === void 0 ? void 0 : ref6.map(function(service) {
                                return {
                                    "@type": "Offer",
                                    "itemOffered": {
                                        "@type": "Service",
                                        "name": service === null || service === void 0 ? void 0 : service.name.replace(/['"]+/g, "")
                                    }
                                };
                            })
                        ]
                    }
                })
            }
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./pages/[partner]/[city]/[slug]/index.tsx









var GarageProfileHeader = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(6114), __webpack_require__.e(893)]).then(__webpack_require__.bind(__webpack_require__, 5527)).then(function(mod) {
    return mod.GarageProfileHeader;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5527)
            ];
        }
    }
});
var GarageProfileHeadline = dynamic_default()(__webpack_require__.e(/* import() */ 1145).then(__webpack_require__.bind(__webpack_require__, 1145)).then(function(mod) {
    return mod.GarageProfileHeadline;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1145)
            ];
        }
    }
});
var GarageProfileHero = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(6889), __webpack_require__.e(5956)]).then(__webpack_require__.bind(__webpack_require__, 6638)).then(function(mod) {
    return mod.GarageProfileHero;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6638)
            ];
        }
    }
});
var GarageProfileBooking = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8085), __webpack_require__.e(135), __webpack_require__.e(6275), __webpack_require__.e(8698), __webpack_require__.e(9384), __webpack_require__.e(4771), __webpack_require__.e(7489), __webpack_require__.e(1833)]).then(__webpack_require__.bind(__webpack_require__, 3105)).then(function(mod) {
    return mod.GarageProfileBooking;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3105)
            ];
        }
    }
});
var GarageProfileOfferings = dynamic_default()(__webpack_require__.e(/* import() */ 7509).then(__webpack_require__.bind(__webpack_require__, 7509)).then(function(mod) {
    return mod.GarageProfileOfferings;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7509)
            ];
        }
    }
});
var GarageProfileMOT = dynamic_default()(__webpack_require__.e(/* import() */ 164).then(__webpack_require__.bind(__webpack_require__, 164)).then(function(mod) {
    return mod.GarageProfileMOT;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(164)
            ];
        }
    }
});
var GarageProfileMapLocation = dynamic_default()(__webpack_require__.e(/* import() */ 9068).then(__webpack_require__.bind(__webpack_require__, 9068)).then(function(mod) {
    return mod.GarageProfileMapLocation;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9068)
            ];
        }
    }
});
var GarageProfileOpeninghours = dynamic_default()(__webpack_require__.e(/* import() */ 3325).then(__webpack_require__.bind(__webpack_require__, 3325)).then(function(mod) {
    return mod.GarageProfileOpeninghours;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3325)
            ];
        }
    }
});
var GarageProfilePickupService = dynamic_default()(__webpack_require__.e(/* import() */ 560).then(__webpack_require__.bind(__webpack_require__, 560)).then(function(mod) {
    return mod.GarageProfilePickupService;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(560)
            ];
        }
    }
});
var GarageProfileAbout = dynamic_default()(__webpack_require__.e(/* import() */ 3646).then(__webpack_require__.bind(__webpack_require__, 3646)).then(function(mod) {
    return mod.GarageProfileAbout;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3646)
            ];
        }
    }
});
var GarageProfileMobileBooking = dynamic_default()(__webpack_require__.e(/* import() */ 7012).then(__webpack_require__.bind(__webpack_require__, 7012)).then(function(mod) {
    return mod.GarageProfileMobileBooking;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7012)
            ];
        }
    }
});
var GarageProfileRatings = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8085), __webpack_require__.e(9733)]).then(__webpack_require__.bind(__webpack_require__, 9733)).then(function(mod) {
    return mod.GarageProfileRatings;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9733)
            ];
        }
    }
});
var Profile = /*#__PURE__*/ react.memo(function(param) {
    var garage = param.garage, nearbyGarages = param.nearbyGarages, partnerConfig = param.partnerConfig, brands = param.brands;
    var ref, ref1, ref2;
    var state = (0,store/* default */.Z)();
    (0,react.useEffect)(function() {
        state.setGarage(garage);
    }, []);
    (0,react.useEffect)(function() {
        var id = crypto.randomUUID();
        {
            (garage === null || garage === void 0 ? void 0 : garage.id) && window.sessionStorage.setItem("correlationID".concat(garage === null || garage === void 0 ? void 0 : garage.id), "".concat(id));
        }
    }, [
        garage
    ]);
    var onSubmit = function(slot) {};
    if (!garage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-theme": partnerConfig.name,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(garage.name, " in ").concat(garage.city)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "".concat(garage.name, " direkt online buchen - Services der Autowerkstatt ").concat(garage.name, " in ").concat(garage.city, ", Bewertungen und weitere KFZ Werkst\xe4tten in ").concat(garage.city, " finden")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#5bbad5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#da532c"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://maps.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://maps.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "canonical",
                        content: "".concat("https://www.repareo.de/").concat(partnerConfig.slug, "/").concat((ref = garage.profileSlug) === null || ref === void 0 ? void 0 : ref.split("/")[0], "/").concat(garage.id, "-").concat((ref1 = garage.profileSlug) === null || ref1 === void 0 ? void 0 : ref1.split("/")[1], "/")
                    }),
                    !partnerConfig.profilePagesIndexable && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, follow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleTagManager/* GoogleTagManager */.f, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileHeader, {
                partner: partnerConfig
            }),
            garage && /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "garageProfile grid grid-cols-12 lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileHeadline, {
                            garage: garage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileHero, {
                            garage: garage,
                            partner: partnerConfig
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "garageProfile__content col-span-full grid grid-cols-12 lg:gap-x-16 order-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-12 lg:col-span-7 grid grid-cols-12 order-2 lg:order-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileOfferings, {
                                            garage: garage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileMOT, {
                                            garage: garage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileMapLocation, {
                                            garage: garage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileOpeninghours, {
                                            garage: garage
                                        }),
                                        garage.premium_services && garage.premium_services.some(function(premiumService) {
                                            return premiumService.type === "CollectAndReturn";
                                        }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfilePickupService, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileAbout, {
                                            garage: garage
                                        }),
                                        ((ref2 = garage.reviews) === null || ref2 === void 0 ? void 0 : ref2.distribution) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileRatings, {
                                            averageRating: garage.rating,
                                            ratingCount: garage.review_count,
                                            garageName: garage.name,
                                            ratings: garage.reviews
                                        }),
                                        partnerConfig.shouldDisplayQuotation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-span-full mb-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-3xl font-serif text-gray-900 font-semibold",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                                        id: "costevaluation_garage",
                                                        name: garage.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#booking",
                                                    className: "relative text-white text-base leading-6 font-medium no-underline block w-full bg-primary-500 px-12 py-2 mt-5 rounded-lg text-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                                        id: "costevaluation_now"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-12 grid lg:col-span-5 grid-cols-12 order-1 lg:order-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileBooking, {
                                        garage: garage,
                                        id: "booking",
                                        onSubmit: onSubmit,
                                        brands: brands,
                                        partner: partnerConfig
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-white w-full fixed left-0 bottom-0 md:invisible grid col-span-12 grid-cols-12 z-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileMobileBooking, {
                                        garage: garage
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            partnerConfig.shouldDisplayFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileFooter, {
                garages: nearbyGarages,
                current: garage,
                partner: partnerConfig
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SchemaMarkup, {
                garage: garage
            })
        ]
    });
});
Profile.displayName = "Garage";
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Profile);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7758,1539,9774,2888,179], function() { return __webpack_exec__(1424); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);